module.exports = __webpack_public_path__ + "img/auto_texts_inactive.a60f25bd.svg";